import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

//DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
//DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';

import { AuthorizationService } from '../authorization.service';
import { SidebarService } from '../sidebar/sidebar.service';
import { ROUTES } from '../routes';
import { HttpService } from './http.service';

@Component({
    selector: 'navbar',
    templateUrl: 'navbar.component.html'
})
export class NavbarComponent implements OnInit, OnDestroy {
    username$: Observable<string>;
    menuItems: any[];

    private toggleButton: Element;
    private unsubscribe$ = new Subject<void>();
    public param1: string;
    public result: any;

    constructor(
        private element: ElementRef,
        private router: Router,
        private config: SocoConfigurationService,
        private authorizationService: AuthorizationService,
        private sidebarService: SidebarService,
        public httpService: HttpService, private route: ActivatedRoute
        
    ) { 
        // console.log('Called Constructor');
        // this.param1 = this.route.snapshot.queryParams.callid;
        // console.log('this.param1', this.param1);
        // this.httpService.getData(this.param1).subscribe(ApiResult => {
        //     this.result = ApiResult;
        // });
    }

    ngOnInit() {
       
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];

        // const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        // const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((event: NavigationEnd) => {
                // this.sidebarService.sidebarClose(this.toggleButton);
                //elemMainPanel.scrollTop = 0;
               // elemSidebar.scrollTop = 0;
            });

        //DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
        let usernameSettingName = 'Username';
        this.username$ = this.config.getSetting<string>(usernameSettingName);

        //request the current user's roles
        this.authorizationService.getCurrentUsersRoles()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(roles => {
            //filter out any menu items that require the user to have roles that the user doesn't have
            this.menuItems = ROUTES.filter(menuItem => roles.some(role => !menuItem.roles || menuItem.roles.length < 1 || menuItem.roles.includes(role)));
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    sidebarToggle() {
        // this.sidebarService.sidebarToggle(this.toggleButton);
    }
}

